export default __webpack_public_path__ + "static/media/sandboard.ea9d493e.png";